import { useOidc } from "@axa-fr/react-oidc"
import { useTranslation } from "react-i18next"

export const ErrorRefreshFallback = () => {
  const { logout } = useOidc()
  const { t } = useTranslation()
  return (
    <div className="flex flex-wrap gap-1 text-janeBlack border border-greyLighter rounded p-6 mt-5">
      <span>{t("error.oopsSomethingWentWrong")}</span>
      <span>
        <a href="#" className="text-janeBlue" onClick={() => logout()}>
          {t("error.refreshPage")}
        </a>
      </span>
    </div>
  )
}
